<template>
  <main class="research" v-if="payload">
    <div class="research__items">
      <research-item v-for="(item, key) in payload.research" :key="`research${key}`" :item="item"></research-item>
    </div>
  </main>
</template>

<script>
import ApiPage from '@/services/ApiPage'

import ResearchItem from '@/views/research/ResearchItem'
export default {
  name: 'Research',
  extends: ApiPage,
  components: {
    ResearchItem
  },
  data() {
    return {
      payload: null
    }
  },
  watch: {
    payload: function(val) {
      if (val) {
        setTimeout(() => {
          window.scrollTo({
            top: this.$store.getters.getResearchScroll,
            left: 0,
            behavior: 'smooth'
          })
        }, 500)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.research {
  @include page;
  &__items {
    display:flex;
    flex-wrap:wrap;
    // justify-content: space-between;
  }
}

</style>
